import React, { useState, useEffect } from 'react';
import { Button } from 'swag-client-common/components/ui/button';
import classnames from 'classnames';
import { MATERIAL_TRANSITION_TIME } from 'swag-client-common/constants';
import { removeSuperSpeedProductIdFromLS, setSuperSpeedProductIdInLS } from 'swag-client-common/utils/super-speed-local-storage.utils';
import Drawer from '../../ui/drawer';
import { TimeTable } from './components/time-table';
import classes from './production-time-dialog.scss';
export const ProductionTimeDialog = ({
  open,
  prodTime,
  productId,
  isBox,
  productionTimeList,
  prerenderForCrawlers = false,
  isLimitedEdition,
  isItemEditing,
  isSharedItem,
  popupParams,
  isEmbroideryEmbellishmentMethod,
  hasProductSuperSpeedProdTime,
  superSpeedProdTimeIdx,
  superSpeedEmbellishmentMethod,
  superSpeedEmbellishmentMethodIdx,
  onUpdateItem,
  onSaveChanges,
  onSharedItemUpdate,
  onOpenConfirmPopup,
  changeEmbellishmentMethod,
  onClose,
  isOnCheckout = false,
  superSpeedProductMaxPrintColors,
  uniqueColorsForOrderItem,
  onShowSuperSpeedColorLimitationPopup
}) => {
  const [localProdTime, setLocalProdTime] = useState(-1);
  const [initialProdTime, setInitialProdTime] = useState(-1);
  useEffect(() => {
    const isExistsProdTime = productionTimeList.find(({
      prodTimeIndex
    }) => prodTimeIndex === localProdTime);
    if (open && (initialProdTime !== prodTime || !isExistsProdTime)) {
      setLocalProdTime(prodTime);
      setInitialProdTime(prodTime);
    }
  }, [open, prodTime]);
  const onRequestClose = () => {
    onClose();
    setTimeout(() => {
      setLocalProdTime(-1);
      setInitialProdTime(-1);
    }, MATERIAL_TRANSITION_TIME);
  };
  const saveChanges = () => {
    const isSameTime = initialProdTime === localProdTime;
    const toSuperSpeed = localProdTime === superSpeedProdTimeIdx;
    const fromSuperSpeed = initialProdTime === superSpeedProdTimeIdx;
    const shouldOpenConfirmPopup = isItemEditing && hasProductSuperSpeedProdTime && (toSuperSpeed || fromSuperSpeed);
    if (isSameTime) {
      return onRequestClose();
    }
    if (isSharedItem && onSharedItemUpdate && localProdTime !== initialProdTime) {
      return onSharedItemUpdate(localProdTime, popupParams, isOnCheckout);
    }
    if (isItemEditing && toSuperSpeed && superSpeedProductMaxPrintColors < uniqueColorsForOrderItem) {
      onShowSuperSpeedColorLimitationPopup();
      setTimeout(() => {
        setLocalProdTime(-1);
        setInitialProdTime(-1);
      }, MATERIAL_TRANSITION_TIME);
      return;
    }
    if (shouldOpenConfirmPopup) {
      return onOpenConfirmPopup({
        toSuperSpeed,
        fromSuperSpeed,
        time: localProdTime,
        methodIdx: superSpeedEmbellishmentMethodIdx,
        methodName: superSpeedEmbellishmentMethod.name,
        prevPopupParams: popupParams
      });
    }
    if (hasProductSuperSpeedProdTime) {
      if (toSuperSpeed) {
        setSuperSpeedProductIdInLS(productId);
        changeEmbellishmentMethod(superSpeedEmbellishmentMethodIdx);
      } else {
        removeSuperSpeedProductIdFromLS();
      }
    }
    onSaveChanges(localProdTime);
    if (isItemEditing) {
      onUpdateItem(localProdTime, isOnCheckout);
    }
    onRequestClose();
  };
  return /*#__PURE__*/React.createElement(Drawer, {
    prerenderForCrawlers: prerenderForCrawlers,
    dataDrawer: "ProductionTime",
    open: open,
    onClose: onRequestClose,
    headerTitle: "Production Time",
    closeClassName: isLimitedEdition ? classes.orangeClose : '',
    bodyClassName: classes.postalWrapper,
    headerClassName: classes.postalHeader
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.content
  }, /*#__PURE__*/React.createElement("p", {
    className: classes.description
  }, "You will receive a production mockup within 48 hours. After you approve your mockup we will start on production.", ' ', isEmbroideryEmbellishmentMethod && `If we are using embroidery to embellish your
          design, you will receive a sewout of your design. This may take up to a week.`), /*#__PURE__*/React.createElement(TimeTable, {
    isBox: !!isBox,
    prodTime: localProdTime,
    editAvailable: productionTimeList.length > 0,
    onChange: setLocalProdTime,
    timeList: productionTimeList,
    isLimitedEdition: !!isLimitedEdition,
    superSpeedMethod: superSpeedEmbellishmentMethod,
    tableClassName: classes.tableClassName
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.confirmRow
  }, /*#__PURE__*/React.createElement(Button, {
    type: "primary",
    onClick: saveChanges,
    className: classnames(classes.confirmButton, {
      [classes.orangeBackground]: isLimitedEdition
    }),
    dataButton: "Confirm"
  }, productionTimeList.length > 1 ? 'Confirm' : 'OK'))));
};